
import React from 'react';
import CalculatorButton from './CalculatorButton';

interface CalculatorKeypadProps {
  onDigitClick: (digit: string) => void;
  onOperatorClick: (operator: string) => void;
  onDecimalClick: () => void;
  onClearClick: () => void;
  onEqualsClick: () => void;
}

const CalculatorKeypad: React.FC<CalculatorKeypadProps> = ({
  onDigitClick,
  onOperatorClick,
  onDecimalClick,
  onClearClick,
  onEqualsClick,
}) => {
  return (
    <div className="grid grid-cols-4 gap-2 p-2 bg-gray-700 rounded-md">
      <CalculatorButton value="C" onClick={onClearClick} variant="control" />
      <CalculatorButton value="+/-" onClick={() => {}} variant="control" />
      <CalculatorButton value="%" onClick={() => {}} variant="control" />
      <CalculatorButton value="÷" onClick={() => onOperatorClick('/')} variant="operation" />

      {[7, 8, 9].map((num) => (
        <CalculatorButton 
          key={num} 
          value={num.toString()} 
          onClick={() => onDigitClick(num.toString())} 
        />
      ))}
      <CalculatorButton value="×" onClick={() => onOperatorClick('*')} variant="operation" />

      {[4, 5, 6].map((num) => (
        <CalculatorButton 
          key={num} 
          value={num.toString()} 
          onClick={() => onDigitClick(num.toString())} 
        />
      ))}
      <CalculatorButton value="-" onClick={() => onOperatorClick('-')} variant="operation" />

      {[1, 2, 3].map((num) => (
        <CalculatorButton 
          key={num} 
          value={num.toString()} 
          onClick={() => onDigitClick(num.toString())} 
        />
      ))}
      <CalculatorButton value="+" onClick={() => onOperatorClick('+')} variant="operation" />

      <CalculatorButton value="0" onClick={() => onDigitClick('0')} variant="wide" />
      <CalculatorButton value="." onClick={onDecimalClick} />
      <CalculatorButton value="=" onClick={onEqualsClick} variant="operation" />
    </div>
  );
};

export default CalculatorKeypad;
